import { RecordingSettings, RoutingStrategy } from '@api/generated/graphql';
import ServiceQueue from '../../types/ServiceQueue';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import refreshQueues from '../../lib/refreshQueues';
import { serviceState } from '../../lib/state';

async function handleQueueCreated(event: Telecom.QueueCreatedEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:created:' + queue?.name, event);

  if (queue) {
    await refreshQueues();
    return;
  }

  const newQueue: ServiceQueue = {
    id: event.queueId,
    name: event.queueName,
    status: {
      abandonedSessions: 0,
      activeSessionCount: 0,
      averageWait: 0,
      estimatedWait: 0,
      longestWait: 0,
      missedSessions: 0,
      recipientCount: 0,
      totalSessions: 0,
      activeRecipientCount: 0,
      availableRecipientCount: 0,
    },
    memberIds: event.agentIds,
    sessions: [],
    inboundRecording: RecordingSettings.Automatically,
    routingStrategy: RoutingStrategy.MostIdle,
  };

  serviceState.queues = [...serviceState.queues, newQueue];
}

export default handleQueueCreated;
